import styled from 'styled-components';
import { Colors } from '../../../assets/styles/StyleTypes'

export const InputWrapper = styled.label`
  position: relative;
  margin: 0;
`;
export const Input = styled.input`
  position: absolute;;
  left: -9999px;
  top: -9999px;
  &:checked + span {
    background-color: ${Colors.PRIMARY_HIGHLIGHT};
    &:before {
      left: 28px;
      background-color: ${Colors.HIGH_PURE};
    }
  }
`;
export const Slider = styled.span`
  display: flex;
  cursor: pointer;
  width: 50px;
  height: 22px;
  border-radius: 100px;
  background-color: ${Colors.HIGH_PURE};
  border: 2px solid ${Colors.PRIMARY_HIGHLIGHT};
  position: relative;
  transition: background-color 0.2s;

  &:before {
    content: "";
    position: absolute;
    top: 2px;
    left: 2px;
    width: 17px;
    height: 17px;
    border-radius: 45px;
    background-color: ${Colors.PRIMARY_HIGHLIGHT};
    box-shadow: 0 2px 4px 0 rgba(0, 35, 11, 0.2);
  }
`;

